import React from 'react';
import { useLocation } from 'react-router';
import cn from 'classnames';
import core, { App } from '@gin-betting/core';

import { Icon, SmartLink } from 'components';
import { ExtendedRouts } from 'app-constants';
import searchIcon from 'assets/svg/search.svg';
import './searchMobile.scss';

const {
    utils: { isOneOfPages },
} = core;

const SearchMobile: React.FC<{}> = () => {
    useLocation();

    return (
        <SmartLink styleName="container" to={ExtendedRouts.SEARCH}>
            <Icon
                styleName={cn('icon', {
                    ['is-active']: isOneOfPages(
                        ([ExtendedRouts.SEARCH] as any) as App.Routes[],
                        { exact: true }
                    ),
                })}
                glyph={searchIcon}
            />
            <input type="text" styleName="fake" />
        </SmartLink>
    );
};

export default SearchMobile;
